module.exports = __webpack_public_path__ + "media/images/states/mn-b59e1e39aef2def184ef11f3b25632c1.png";